import { render, staticRenderFns } from "./Cook.vue?vue&type=template&id=5dbd7b6a&scoped=true&"
import script from "./Cook.vue?vue&type=script&lang=js&"
export * from "./Cook.vue?vue&type=script&lang=js&"
import style0 from "./Cook.vue?vue&type=style&index=0&id=5dbd7b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd7b6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VDivider,VRow})
